var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drop collapse mt-5",attrs:{"id":"addCardBlock"}},[_c('PaymentForm',{ref:"paymentForm",attrs:{"input_countries":_vm.countries,"input_states":_vm.states},on:{"create":_vm.createPayment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }